import CollapsibleNavigation from "./CollapsibleNavigation";

function Header(){
    return (
        <div className="container mx-0 card header box-shadow" id="header">
            <header className="d-flex flex-wrap justify-content-center py-1 mb-3 mb-md-4 border-bottom">
            <a
                href="/"
                className="d-flex align-items-center mb-0 me-auto me-md-0 link-body-emphasis text-decoration-none"
            >
                <img
                className="me-2 header-image"
                src={process.env.PUBLIC_URL + "/images/logo_circle.png"}
                alt="Logo"
                />
                <span
                className="fs-5 fs-sm-1 quint palegreen"
                style={{ fontWeight: 600 }}
                >
                Egészség Energia Egyensúly
                </span>
            </a>
            <button
                className="btn btn-primary d-flex d-md-none my-auto menu-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
            >
                <i className="bi bi-list fs-4" />
            </button>
            </header>
            <CollapsibleNavigation />
        </div>
    );
}

export default Header;